import { Suspense } from "react";
import { createHashRouter } from "react-router-dom";
import MobileLayout from "../../layouts/Mobile";
import { routes } from "./routes";
import { PageSizeLoader } from "../../components/CustomComponents/PageSizeLoader";
import { AppErrorBoundary } from "../../components/CustomComponents/PageErrorBoundry";
import { ErrorComponent } from "../../components/CustomComponents/PageErrorBoundry/ErrorComponent";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { HomeHealthRouteGuard } from "./HomeHealthRouteGuard";

export const mobileRouter = (connectionStatus: boolean) =>
  createHashRouter([
    {
      path: "/",
      element: <MobileLayout />,
      children: Object.entries(routes).map(([_, route]) => ({
        ...route,
        element: (
          <AppErrorBoundary
            FallbackComponent={({ error, resetErrorBoundary }) => (
              <ErrorComponent
                error={error}
                resetErrorBoundary={resetErrorBoundary}
                connectionStatus={connectionStatus}
              />
            )}
            resetKeys={[route.path]}
          >
            <Suspense
              fallback={
                <PageSizeLoader
                  loader={
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 48, color: "#161646" }}
                          spin
                        />
                      }
                    />
                  }
                />
              }
            >
              <HomeHealthRouteGuard>
                <route.element />
              </HomeHealthRouteGuard>
            </Suspense>
          </AppErrorBoundary>
        ),
      })),
    },
  ]);
